// @flow
import React from 'react';
import { getIn, useFormikContext } from 'formik';

import { TabsContainer } from '../../presentational/TabsContainer';
import { WarningIcon } from '../../presentational/icons/WarningIcon';
import { PaddedAndRaisedSegment } from '../../presentational/PaddedAndRaisedSegment';
import { StyledH4 } from '../../presentational/headings/StyledH4';
import {
  IS_NATIVE_INFERENCE_CCU_LIVE_IN_CE1,
  NATIVE_INFERENCE_POOL_CCU_MONTHLY_INPUTS_JSON_CONFIG,
  NATIVE_INFERENCE_POOL_TOKEN_BASED_MODELS_JSON_CONFIG,
} from '../../../constants';

import { NativeInferencePoolComputeBasedUsageContainer } from './NativeInferencePoolComputeBasedUsageContainer';
import { NativeInferencePoolTokenBasedUsageContainer } from './NativeInferencePoolTokenBasedUsageContainer';

export const NativeInferencePoolUsageContainer = () => {
  const { errors } = useFormikContext();

  const areAnyErrorsPresentInComputeBasedTab =
    getIn(errors, NATIVE_INFERENCE_POOL_CCU_MONTHLY_INPUTS_JSON_CONFIG) != null;

  const areAnyErrorsPresentInTokenBasedTab =
    getIn(errors, NATIVE_INFERENCE_POOL_TOKEN_BASED_MODELS_JSON_CONFIG) != null;

  const tabPanes = [
    {
      menuItem: {
        key: 'compute-based-model',
        icon: areAnyErrorsPresentInComputeBasedTab ? <WarningIcon /> : null,
        content: <>Compute-Based Model</>,
      },
      render: () =>
        IS_NATIVE_INFERENCE_CCU_LIVE_IN_CE1 ? (
          <NativeInferencePoolComputeBasedUsageContainer />
        ) : (
          <PaddedAndRaisedSegment>
            <StyledH4 text="Compute-Based (CCU) pricing is not generally available yet" />
          </PaddedAndRaisedSegment>
        ),
    },
    {
      menuItem: {
        key: 'token-based-model',
        icon: areAnyErrorsPresentInTokenBasedTab ? <WarningIcon /> : null,
        content: <>Token-Based Model</>,
      },
      render: () => <NativeInferencePoolTokenBasedUsageContainer />,
    },
  ];

  return <TabsContainer tabPanes={tabPanes} />;
};
